<script setup lang="ts">
import { useToastStore } from '~/stores/toast'

const toastStore = useToastStore()

const icons = {
  success: 'check-circle',
  error: 'error',
  info: 'info',
  warning: 'warning',
}
</script>

<template>
  <div class="toast-stack">
    <TransitionGroup name="toast">
      <div
        v-for="toast in toastStore.toasts"
        :key="toast.id"
        class="toast-item"
        :class="`toast-${toast.type}`"
        @click="toastStore.remove(toast.id)"
      >
        <Icon :name="`material-symbols:${icons[toast.type] || 'info'}`" class="toast-icon" />
        <span>{{ toast.message }}</span>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped>
.toast-stack {
  position: fixed;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  pointer-events: none;
}

.toast-item {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 12px 20px;
  border-radius: 14px;
  font-size: 13.5px;
  font-weight: 700;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  pointer-events: all;
  cursor: pointer;
  white-space: nowrap;
}

.toast-success {
  background: #0f172a;
  color: #fff;
}

.toast-error {
  background: #ef4444;
  color: #fff;
}

.toast-info {
  background: #137fec;
  color: #fff;
}

.toast-warning {
  background: #f59e0b;
  color: #fff;
}

.toast-icon {
  font-size: 17px;
  flex-shrink: 0;
}

.toast-enter-active,
.toast-leave-active {
  transition: all 0.25s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateY(-12px) scale(0.95);
}

.toast-leave-to {
  opacity: 0;
  transform: translateY(-8px) scale(0.95);
}
</style>
